import { render, staticRenderFns } from "./UploadAsTemplate.vue?vue&type=template&id=38b46b6b"
import script from "./UploadAsTemplate.vue?vue&type=script&lang=js"
export * from "./UploadAsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports